export default __webpack_public_path__ + "static/Jacksonville_AdobeStock_75861357-932ef93028fd16a2bdc9fbe121ccf0d5.jpeg";